export * from "./forsyning-paa-adresse.component";
export * from "./forsyning-paa-adresse.module";
export * from "./model/forsyning-paa-adresse.model";
export * from "./services/forsyning-paa-adresse.repository";
